import React, { useState, useEffect } from 'react';


const baseURL = process.env.PUBLIC_URL + '/assets/';


const ImageSlider = ({ images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Function to handle auto-scrolling
  const autoScroll = () => {
    const nextIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(nextIndex);
  };

  // Function to handle manual sliding
  const handleSlide = (direction) => {
    const nextIndex =
      direction === 'next'
        ? (currentImageIndex + 1) % images.length
        : (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(nextIndex);
  };

  useEffect(() => {
    // Set up a timer to auto-scroll every 5 seconds (adjust as needed)
    const autoScrollTimer = setInterval(autoScroll, 5000);

    // Clean up the timer when the component is unmounted
    return () => clearInterval(autoScrollTimer);
  }, [currentImageIndex, images.length]);

  return (
    <div className='relative w-full mt-24 '>
      <img
        src={images[currentImageIndex]}
        alt={`Image ${currentImageIndex + 1}`}
        className='w-full h-90vh aspect-[2.05] max-md:aspect-[1.5] object-cover mt-16 max-md:m-0'
      />
      {/* Arrow buttons */}
      <button
        onClick={() => handleSlide('prev')}
        className='absolute text-5xl font-medium text-footer-blue-custom2 top-1/2 left-4 transform -translate-y-1/2 focus:outline-none '
      >
              <img
        loading="lazy"
        src={`${baseURL}/left.svg`}         
        className="w-16 h-16 "
      />

      
      </button>
      <button
        onClick={() => handleSlide('next')}
        className='absolute text-5xl font-medium text-footer-blue-custom2 top-1/2 right-4 transform -translate-y-1/2 focus:outline-none '
      >
      <img
              loading="lazy"
              src={`${baseURL}/right.svg`}         
              className="w-16 h-16 "
       />     
               </button>
    </div>
  );
};

export default ImageSlider;

